import { render, staticRenderFns } from "./cabinet-notifications-list.vue?vue&type=template&id=28305866&scoped=true&"
import script from "./cabinet-notifications-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-notifications-list.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-notifications-list.vue?vue&type=style&index=0&id=28305866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28305866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28305866')) {
      api.createRecord('28305866', component.options)
    } else {
      api.reload('28305866', component.options)
    }
    module.hot.accept("./cabinet-notifications-list.vue?vue&type=template&id=28305866&scoped=true&", function () {
      api.rerender('28305866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/notifications/cabinet-notifications-list.vue"
export default component.exports